import {createElement, Component, PropTypes} from 'rlink-react';
import contentLoader from 'helpers/content-loader';
import css from 'static/style/dow.less';

export default class AbilityCard extends Component {
  render () {
    return (
      <div className={css['ability-preview']}>
        <div className={css['ability-widget']}>
          <header>
            <h3>{this.props.title}</h3>
          </header>
          <div className={css.content}>
            <div>
              <p>{this.props.description}</p>
            </div>
          </div>
          <AbilityPreviewVideo mediaName={this.props.mediaName} />
        </div>
      </div>);
  }
}

class AbilityPreviewVideo extends Component {
  render () {
    return (
      <div className={css['media-wrapper']}>
        <div className={css['ability-media']}>
          <div className={css.overlay} />
          <video
            ref={el => {
              if (el) {
                el.onmouseover = () => el.play();
                el.onmouseout = () => el.pause();
              }
            }}
            className={css['bg-media']}
            loop
            muted
            poster={contentLoader(`${this.props.mediaName}-video-poster.jpg`)}
            preload="auto"
            width="100%">
            <source src={contentLoader(`${this.props.mediaName}.webm`, 'video')} type="video/webm" />
            <source src={contentLoader(`${this.props.mediaName}.mp4`, 'video')} type="video/mp4" />
          </video>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/ability-card.jsx